var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer-right",class:{ visible: _vm.isVisible }},[_vm._m(0),_c('FamilyDropdown')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer-title"},[_vm._v(" SK’s Journey with "),_c('br'),_vm._v(" Challenge, Passion and Integrity ")])
}]

export { render, staticRenderFns }